// @translateEnum(kpi:description., kpi:)
export enum ProductKPI {
    ClickCount = 'clickCount',
    CartCount = 'cartCount',
    CheckoutCount = 'checkoutCount',
    AsnClickCount = 'asnClicks',
    NaviClickCount = 'naviClicks',
    UniqueClickCount = 'uniqueClickCount',
    ClickToCartRate = 'clickToCartRate',
    CartToCheckoutRate = 'cartToCheckoutRate',
    Sales = 'sales',
    SalesPerClick = 'salesPerClick',
}

// @translateEnum(kpi:description., kpi:)
export enum SearchtermKPI {
    SearchCount = 'searchCount',
    ClickCount = 'clickCount',
    CartCount = 'cartCount',
    CheckoutCount = 'checkoutCount',
    AsnClickCount = 'asnClicks',
    NaviClickCount = 'naviClicks',
    ClickRate = 'clickRate',
    ClickToCartRate = 'clickToCartRate',
    CartToCheckoutRate = 'cartToCheckoutRate',
    SalesFromSearches = 'salesFromSearches',
    SalesFromSearchesPerSearch = 'salesFromSearchesPerSearch',
    SalesFromSearchesPerClick = 'salesFromSearchesPerClick',
    AvgMatchCount = 'avgMatchCount',
    UniqueClickRate = 'uniqueClickRate',
    UniqueClickCount = 'uniqueClickCount',
    ClickToBuyRate = 'clickToBuyRate',
    ResultCount = 'resultCount',
    AvgResultCount = 'avgResultCount',
    CheckoutPerSearchRate = 'checkoutPerSearchRate',
    AvgBestSimi = 'avgBestSimi',
    AvgPos = 'avgPos',
}

// @translateEnum(kpi:description., kpi:)
export enum CampaignKPI {
    Name = 'name',
    Category = 'category',
    Flavour = 'flavour',
    AvgPushedProductsCount = 'avgPushedProductsCount',
    SearchCount = 'searchCount',
    UniqueSearchCount = 'uniqueSearchCount',
    ClickCount = 'clickCount',
    UniqueClickCount = 'uniqueClickCount',
    CartCount = 'cartCount',
    CheckoutCount = 'checkoutCount',
    Sales = 'sales',
    ClickRate = 'clickRate',
    UniqueClickRate = 'uniqueClickRate',
    BounceRate = 'bounceRate',
    ExitRate = 'exitRate',
    ClickToCartRate = 'clickToCartRate',
    ClickToBuyRate = 'clickToBuyRate',
    CheckoutPerSearchRate = 'checkoutPerSearchRate',
    CartToCheckoutRate = 'cartToCheckoutRate',
    SalesPerSearch = 'salesPerSearch',
    SalesPerClick = 'salesPerClick',
    AvgCartValue = 'avgCartValue',
}

// @translateEnum(kpi:description., kpi:)
export enum SearchtermSlopeOutlierKPI {
    SearchSlopeValue = 'searchSlopeValue',
    SearchOutlierScore = 'searchOutlierScore',
    MaxSearchSlopeValue = 'maxSearchSlopeValue',
    MinSearchSlopeValue = 'minSearchSlopeValue',
    ClickSlopeValue = 'clickSlopeValue',
    ClickOutlierScore = 'clickOutlierScore',
    MaxClickSlopeValue = 'maxClickSlopeValue',
    MinClickSlopeValue = 'minClickSlopeValue',
    CartSlopeValue = 'cartSlopeValue',
    CartOutlierScore = 'cartOutlierScore',
    MaxCartSlopeValue = 'maxCartSlopeValue',
    MinCartSlopeValue = 'minCartSlopeValue',
    CheckoutSlopeValue = 'checkoutSlopeValue',
    CheckoutOutlierScore = 'checkoutOutlierScore',
    MaxCheckoutSlopeValue = 'maxCheckoutSlopeValue',
    MinCheckoutSlopeValue = 'minCheckoutSlopeValue',
    SalesFromSearchesSlopeValue = 'salesFromSearchesSlopeValue',
    SalesFromSearchesOutlierScore = 'salesFromSearchesOutlierScore',
    MaxSalesFromSearchesSlopeValue = 'maxSalesFromSearchesSlopeValue',
    MinSalesFromSearchesSlopeValue = 'minSalesFromSearchesSlopeValue',
}

// @translateEnum(kpi:description., kpi:)
export enum ProductSlopeOutlierKPI {
    ClickSlopeValue = 'clickSlopeValue',
    ClickOutlierScore = 'clickOutlierScore',
    MaxClickSlopeValue = 'maxClickSlopeValue',
    MinClickSlopeValue = 'minClickSlopeValue',
    CartSlopeValue = 'cartSlopeValue',
    CartOutlierScore = 'cartOutlierScore',
    MaxCartSlopeValue = 'maxCartSlopeValue',
    MinCartSlopeValue = 'minCartSlopeValue',
    CheckoutSlopeValue = 'checkoutSlopeValue',
    CheckoutOutlierScore = 'checkoutOutlierScore',
    MaxCheckoutSlopeValue = 'maxCheckoutSlopeValue',
    MinCheckoutSlopeValue = 'minCheckoutSlopeValue',
    SalesSlopeValue = 'salesSlopeValue',
    SalesOutlierScore = 'salesOutlierScore',
    MaxSalesSlopeValue = 'maxSalesSlopeValue',
    MinSalesSlopeValue = 'minSalesSlopeValue',
}

// @translateEnum(kpi:description., kpi:)
export enum SessionInsightKPI {
    Sales = 'sales',
    ClickCount = 'clickCount',
    SearchEvents = 'searchEvents',
    CartEvents = 'cartEvents',
    CartTotalAmount = 'cartTotalAmount',
    CheckoutEvents = 'checkoutEvents',
    CheckoutTotalAmount = 'checkoutTotalAmount',
}

// @translateEnum(kpi:description., kpi:)
export enum KPIGroupKey {
    Searchterm = 'searchterm',
    ProductId = 'productId',
    Channel = 'channel',
    CampaignId = 'id',
}

// @translateEnum(kpi:description., kpi:)
export enum DescriptiveKPIAdditions {
    Title = 'title',
    Channel = 'channel',
}

// @translateEnum(kpi:description., kpi:)
export enum KPISpecialCases {
    RequestCount = 'requestCount',
    AvgSearchTime = 'avgSearchTime',
}

export const isSearchSlopeOutlierKPI = (value: any): value is SearchtermSlopeOutlierKPI => {
    return value !== undefined && Object.values(SearchtermSlopeOutlierKPI).indexOf(value) !== -1;
};

export const isProductSlopeOutlierKPI = (value: any): value is ProductSlopeOutlierKPI => {
    return value !== undefined && Object.values(ProductSlopeOutlierKPI).indexOf(value) !== -1;
};

export const isSessionInsightKPI = (value?: string): value is SessionInsightKPI => {
    return value !== undefined && Object.values(SessionInsightKPI).indexOf(value as any) !== -1;
};

export const isKPI = (value: any): value is KPI => {
    return Object.values(KPI).indexOf(value) !== -1;
};

export const isKpiWithGroupKeys = (value: string): value is KpiWithGroupKeys => {
    return Object.values(KpiWithGroupKeys).indexOf(value as any) !== -1;
};

export const isKpiGroupKeyOrDescriptiveKpiAdditions = (value: string): value is KpiGroupKeyOrDescriptiveKpiAdditions => {
    return Object.values(KpiGroupKeyAndDescriptiveKpiAdditions).indexOf(value as any) !== -1;
};

const KpiGroupKeyAndDescriptiveKpiAdditions = {
    ...KPIGroupKey,
    ...DescriptiveKPIAdditions,
};

export type KpiGroupKeyOrDescriptiveKpiAdditions = KPIGroupKey | DescriptiveKPIAdditions;

const KPI = {
    ...SearchtermKPI,
    ...CampaignKPI,
    ...ProductKPI,
    ...KPISpecialCases,
    ...SearchtermSlopeOutlierKPI,
    ...ProductSlopeOutlierKPI,
    ...DescriptiveKPIAdditions,
};

export type KPI = SearchtermKPI | CampaignKPI | ProductKPI | KPISpecialCases | SearchtermSlopeOutlierKPI | ProductSlopeOutlierKPI;

const KpiWithGroupKeys = {
    ...KPI,
    ...KPIGroupKey,
};

export type KpiWithGroupKeys = KPI | KPIGroupKey;

export type LongtailKPI = SearchtermKPI.SearchCount | SearchtermKPI.ClickCount | SearchtermKPI.CartCount | SearchtermKPI.CheckoutCount;

export const tKeyKpiDescription = (kpi: KpiWithGroupKeys): string => {
    return 'kpi:description.' + kpi;
};

export const tKeyKpi = (kpi: KPI | KPIGroupKey | DescriptiveKPIAdditions) => {
    return 'kpi:' + kpi;
};



// WEBPACK FOOTER //
// ./src/kpi.ts